import AbstractAPI from '@/services/api/AbstractAPI';

export default class AuthApi extends AbstractAPI {

  constructor(client, options) {
    super(client, options);
  }

  async authenticate(username, password) {
    return this.makeRequest('/authenticate', 'post', {
      username: username,
      password: password
    });
  }

  async tokenAuthenticate(credentials) {
    return this.makeRequest('/authenticate-token', 'post', {
      token: credentials.token,
      selector: credentials.selector
    });
  }

  async authorize() {
    return this.makeRequest('/authorize', 'get');
  }

  async clear() {
    return this.makeRequest('/log-out', 'get');
  }

  async sendPasswordResetEmail(email) {
    return this.makeRequest('/forgot-password', 'post', {email});
  }

  async checkPasswordResetToken(token, email) {
    return this.makeRequest('/check-reset-token', 'get', {params: {token, email}});
  }

  async resetPassword(token, email, password, confirmed_password) {
    return this.makeRequest('/reset-password', 'post', {token, email, new_password: password, confirmed_password});
  }
}
